function MaxListLen (value, maxlen) {
    if (value && value !== '') {
        let valueArray = value.split(',');
        if (valueArray.length > maxlen) {
            return false;
        }
        return true;
    }
    return true;
}

export default MaxListLen;
